document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var images = carousel.querySelectorAll('[data-carousel-img]');
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    if (images.length < 2) return;

    var current = 0;

    function show(index) {
      images[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + images.length) % images.length;
      images[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });

    var startX = 0;
    carousel.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 30) return;
      show(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  });

  // Carrousel d'avis clients : défilement automatique
  document.querySelectorAll('[data-avis-carousel]').forEach(function (carousel) {
    var cards = carousel.querySelectorAll('[data-avis-card]');
    var dots = carousel.querySelectorAll('.lnd-avis-dot');
    if (cards.length < 2) return;

    var current = 0;
    var intervalId;

    function show(index) {
      cards[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + cards.length) % cards.length;
      cards[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function startAuto() {
      intervalId = setInterval(function () { show(current + 1); }, 4500);
    }
    function stopAuto() {
      clearInterval(intervalId);
    }

    startAuto();
    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAuto();
        show(i);
        startAuto();
      });
    });
  });
});